import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import {Observable} from "rxjs/index";
import {HttpService} from '../http.service';
import { DATAS } from '../../assets/data/data';
import { trigger, transition, animate, style } from '@angular/animations';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.css'],
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('2s', style({ opacity: 1 })),
      ]),
      /*
      transition(':leave', [
        animate('2s', style({ opacity: 0 }))
      ])
      */
    ]),
  ],
})

export class QuizComponent implements OnInit {

  contact;
  datas=DATAS;
  index=0;
  win;
  loose;
  hidde;
  displayWin=false;
  displayLoose=false;
  private score=0;
  private enableClickButton=true;
  private timeOut;
  enableNextButton=false;

  constructor(public httpService: HttpService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.contact = this.route.snapshot.paramMap;
    this.contact = this.contact.params;
    this.contact = JSON.stringify(this.contact);
    this.contact = JSON.parse(this.contact);
    this.contact["score"]=0;
    this.populateInitialResponsesClass();
    this.startTimeOut();
  }

  postContactForm(data) {
    this.httpService.postContactForm(data);
  }

  clickResponse(index) {
    console.log(index);
    if (this.enableClickButton) {
      this.desableButton();
      this.treatResponse(index);
    }
  }

  clickNextQuestion() {
    clearTimeout(this.timeOut);
    if (this.index<4) {
      this.goToNextQuestion();
    }
    else {
      this.goToEnd();
    }
  }

  desableButton() {
    console.log('desable Button');
    this.enableClickButton=false;
  }

  treatResponse(index) {
    this.hiddeAll();
    if (index==this.datas.quiz[this.index].goodResponses) {
      this.score++;
      this.win[index]=true;
      this.hidde[index]=false;
      this.displayWin=true;
    }
    else {
      this.loose[index]=true;
      this.hidde[index]=false;
      this.win[Number(this.datas.quiz[this.index].goodResponses)]=true;
      this.hidde[Number(this.datas.quiz[this.index].goodResponses)]=false;
      this.displayLoose=true;
    }

    this.enableNextButton=true;
    /*
    clearTimeout(this.timeOut);
    setTimeout(()=>{    //<<<---    using ()=> syntax
      if (this.index<4) {
        this.goToNextQuestion();
      }
      else {
        this.goToEnd();
      }
    }, 5000);
    */
  }

  hiddeAll() {
    this.hidde = [];
    for (var  i=0; i<this.datas.quiz.length; i++) {
      this.hidde.push(true);
    }
  }

  populateInitialResponsesClass() {
    this.win = [];
    this.loose = [];
    this.hidde = [];
    for (var  i=0; i<this.datas.quiz.length; i++) {
      this.win.push(false);
      this.loose.push(false);
      this.hidde.push(false);
    }
  }

  goToNextQuestion() {
    this.index++;
    this.enableClickButton=true;
    this.enableNextButton=false;
    this.displayWin=false;
    this.displayLoose=false;
    this.populateInitialResponsesClass();
    this.startTimeOut();
  }

  goToEnd() {
    this.contact.score=this.score;
    console.log(this.contact);
    this.postContactForm(this.contact);
    console.log("go to end");
    this.router.navigate(['end/'+this.score]);
  }

  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.router.navigate(['home']);
    }, 120000);
  }

}
